module.exports = __webpack_public_path__ + "static/Ranger - How to Create a New Report Version-43e178967d338035a9361a70f0f72c40.pdf";